import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { auth } from "auth/FirebaseAuth";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { trackPageView, trackSessionEnd, trackSessionStart } from "services/UsageTrackingService";

/**
 * Track A: registra page-views por rota da aplicação e tenta marcar o fim de
 * sessão ao fechar/atualizar a aba (best-effort). Renderizado dentro do Router.
 * Não renderiza nada.
 */
const UsageTracker = () => {
  const location = useLocation();
  const user = useSelector((state: any) => state?.auth?.user);
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    const email = user?.email;
    if (!email) return;

    const path = location.pathname;
    if (!path.startsWith(APP_PREFIX_PATH)) return;

    const key = `${email}::${path}`;
    if (lastKey.current === key) return;
    lastKey.current = key;

    trackPageView(path, email);
  }, [location.pathname, user]);

  useEffect(() => {
    // pagehide (e não beforeunload): o XHR da fila não completa no unload; o
    // flush usa fetch(keepalive), que sobrevive à saída da página.
    const handlePageHide = () =>
      trackSessionEnd(auth.currentUser?.email || undefined, { flush: true });

    // Volta do bfcache: a sessão foi encerrada no pagehide; reabre uma nova.
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && auth.currentUser?.email) {
        trackSessionStart(auth.currentUser.email);
      }
    };

    window.addEventListener("pagehide", handlePageHide);
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pagehide", handlePageHide);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return null;
};

export default UsageTracker;
